export const features = {
  GIS: { key: 'gis', description: 'Enables Spatial Analysis functionality', settingsPrefix: 'gis-' },
  MailChimp: { key: 'mailchimp', description: 'Enables MailChimp Integration', settingsPrefix: 'mailchimp-' },
  Zendesk: { key: 'zendesk', description: 'Enables Zendesk Integration', settingsPrefix: 'zendesk-' },
};

export interface Feature {
  key: string;
  description: string;
  settingsPrefix?: string;
}
